import { checkAvailability, getPlugin } from './common';
export function cordovaPropertyGet(pluginObj, key) {
    if (checkAvailability(pluginObj, key) === true) {
        return getPlugin(pluginObj.constructor.getPluginRef())[key];
    }
    return null;
}
export function cordovaPropertySet(pluginObj, key, value) {
    if (checkAvailability(pluginObj, key) === true) {
        getPlugin(pluginObj.constructor.getPluginRef())[key] = value;
    }
}
//# sourceMappingURL=cordova-property.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ionic-native/core/decorators/cordova-property.js
// module id = 1113
// module chunks = 1